/* DEBOER — blog reading-progress bar (shared)
   Shopify: assets/deboer-blog.js → {{ 'deboer-blog.js' | asset_url | script_tag }} */
(function(){
  var bar = document.getElementById('progress');
  if(!bar) return;
  function upd(){
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    var p = max > 0 ? (h.scrollTop || document.body.scrollTop) / max : 0;
    bar.style.width = (p * 100) + '%';
  }
  document.addEventListener('scroll', upd, {passive:true});
  window.addEventListener('resize', upd);
  upd();
})();

/* Article share: native share sheet where available, copy-link fallback. */
(function(){
  var btn = document.querySelector('[data-share]');
  if(!btn) return;
  var url = btn.getAttribute('data-share-url');
  var title = btn.getAttribute('data-share-title');
  btn.addEventListener('click', function(){
    if(navigator.share){
      navigator.share({title: title, url: url}).catch(function(){});
    } else if(navigator.clipboard){
      navigator.clipboard.writeText(url).then(function(){
        var prev = btn.textContent;
        btn.textContent = btn.getAttribute('data-copied-label') || prev;
        setTimeout(function(){ btn.textContent = prev; }, 2000);
      });
    }
  });
})();
